import React from "react";
import {
  Box,
  Typography,
  Stack,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import {
  PinOutlined as PinIcon,
  FlightTakeoffOutlined as LaunchIcon,
  EmojiEventsOutlined as PrizeIcon,
  TrendingUp as RolloverIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { LOTTERY_NAMES } from "../../../../../static/Constants";

const STEPS = [
  {
    step: "01",
    title: "Calibrate Target Code",
    desc: "Use the digital keypad or Random Target generator to pick your exact launch coordinate sequence.",
    icon: <PinIcon sx={{ color: colors.amber[600], fontSize: 24 }} />,
  },
  {
    step: "02",
    title: "Lock Trajectory Ticket",
    desc: "Confirm your selection and authorize the blockchain transaction to mint your missile lottery entry.",
    icon: <LaunchIcon sx={{ color: colors.amber[600], fontSize: 24 }} />,
  },
  {
    step: "03",
    title: "Win or Rollover",
    desc: "Chainlink VRF resolves the target upon launch. Match the coordinate to win or watch the jackpot rollover!",
    icon: <PrizeIcon sx={{ color: colors.emerald[600], fontSize: 24 }} />,
  },
];

const MissileHowToPlay = () => {
  return (
    <Card
      sx={{
        borderRadius: borderRadiusPx.xl,
        border: `1px solid ${colors.slate[200]}`,
        boxShadow: "none",
        bgcolor: colors.dashboard.cardBg,
        mb: 3,
      }}
    >
      <CardContent sx={{ p: { xs: 2.5, sm: 3.5 } }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 800,
            color: colors.slate[900],
            mb: 0.5,
          }}
        >
          {`How ${LOTTERY_NAMES.ROCKETBET} Works`}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: colors.slate[500], mb: 3 }}
        >
          {`${LOTTERY_NAMES.ROCKETBET} is a multi-tier progressive lottery game with verifiable randomness.`}
        </Typography>

        {/* 3 Step Cards */}
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          {STEPS.map((item) => (
            <Grid item xs={12} md={4} key={item.step}>
              <Box
                sx={{
                  p: 2.5,
                  borderRadius: borderRadiusPx.lg,
                  bgcolor: colors.slate[50],
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ mb: 1.5 }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: borderRadiusPx.md,
                      bgcolor: "#ffffff",
                      border: `1px solid ${colors.slate[200]}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 800,
                      color: colors.slate[400],
                      fontSize: "0.85rem",
                    }}
                  >
                    STEP {item.step}
                  </Typography>
                </Stack>

                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 700, color: colors.slate[900], mb: 0.75 }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], fontSize: "0.825rem", lineHeight: 1.55 }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Rollover Tier Progression Details Box */}
        <Box
          sx={{
            p: 2.5,
            borderRadius: borderRadiusPx.lg,
            bgcolor: colors.slate[900],
            color: "#ffffff",
            border: `1px solid ${colors.slate[800]}`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1 }}>
            <RolloverIcon sx={{ color: colors.amber[400] }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#ffffff" }}>
              Progressive Tier Scaling Mechanic
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            sx={{ color: colors.slate[300], fontSize: "0.825rem", lineHeight: 1.6 }}
          >
            Each time a round finishes without a winner, the lottery rolls over and
            levels up: <strong>Initiation (Level 1)</strong> →{" "}
            <strong>Cruise (Level 2)</strong> → <strong>Ballistic (Level 3)</strong> →{" "}
            <strong>Hypersonic (Level 4)</strong>. Unclaimed jackpots accumulate across
            rollovers to produce massive jackpot pools.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MissileHowToPlay;
